/**
 * Returns the smallest element in an array
 */
export default function min(target) {
  return Math.min.apply(0, target);
}
